import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=658a99ae&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"
import style0 from "./recommend.vue?vue&type=style&index=0&id=658a99ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a99ae",
  null
  
)

export default component.exports